<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button routerLink="/">{{ 'HOME' | translate }}</ion-button>
    </ion-buttons>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="flex justify-center">
      <work-ui-logo />
    </div>

    <div class="padding-vertical-24">
      <h1 class="work-text-align-center">{{ 'TEAM_LOGIN' | translate }}</h1>
      <p class="work-text-align-center">
        {{ 'LOGIN_NUR_FUER_SFG_MITARBEITENDE' | translate }}
      </p>
    </div>

    <form [formGroup]="formGroup" autocomplete="off">
      <work-ui-input-field
        formControlName="mobileNumber"
        label="MOBILENUMMER"
        type="tel"
        placeholder="+41 79 123 45 67"
        [required]="true"
      ></work-ui-input-field>

      <work-ui-button
        text="LOGIN"
        variant="primary"
        type="submit"
        [fullWidth]="true"
        [disabled]="!formGroup.controls.mobileNumber.valid"
        (buttonClick)="login()"
      ></work-ui-button>
    </form>
  </div>
</ion-content>
